export const claimsPl = {
  "caseList": "Lista spraw",
  "searchAction": "Szukaj",
  "emptyCases": "Nie znaleziono spraw. Zmień filtry lub utwórz nową sprawę.",
  "newCaseHint": "Zacznij od podstawowych danych. Dokumenty, zadania i korespondencję dodasz po utworzeniu sprawy.",
  "basics": "1. Sprawa i klient",
  "incidentAndPolicy": "2. Zdarzenie i ubezpieczenie",
  "workflow": "Etapy likwidacji szkody",
  "overviewShort": "Dane",
  "mailShort": "E-maile",
  "tasksShort": "Zadania",
  "financesShort": "Finanse",
  "timelineShort": "Historia",
  "people": "Klienci i uczestnicy",
  "assets": "Przedmioty szkody",
  "policies": "Polisy",
  "incident": "Zdarzenie",
  "editShort": "Edytuj",
  "saveNote": "Dodaj notatkę",
  "noPeople": "Brak uczestników",
  "noAssets": "Brak przedmiotów szkody",
  "noPolicies": "Nie dodano polisy",
  "noDocuments": "Nie dodano jeszcze dokumentów do tej sprawy.",
  "noLinks": "Nie utworzono jeszcze linków do dokumentów.",
  "noEmails": "Brak korespondencji w tej sprawie.",
  "noTasks": "Brak zadań i pozycji checklisty.",
  "noFinances": "Nie zapisano jeszcze roszczeń, decyzji ani wypłat.",
  "noHistory": "Brak zdarzeń w historii sprawy.",
  "mailReviewRequired": "Status tej wysyłki jest niepewny. Sprawdź historię sprawy i folder Wysłane w skrzynce, zanim przygotujesz nową próbę. Ponowne wysłanie może doręczyć duplikat.",
  "mailCheckedNew": "Sprawdziłem pocztę — nowa próba",
  "older": "Pokaż starsze wpisy",
  "edit": "Edytuj dane sprawy",
  "role": "Rola podmiotu",
  "identifier": "Identyfikator (np. VIN, nr seryjny)",
  "roles": {"CUSTOMER":"Klient","INSURED":"Ubezpieczony","VICTIM":"Poszkodowany","PERPETRATOR":"Sprawca","WITNESS":"Świadek","PARTNER":"Partner"},
  "title": "Likwidacja szkód",
  "subtitle": "Sprawy BTP i klientów zewnętrznych",
  "newCase": "Nowa sprawa",
  "inbox": "Centralny inbox",
  "scannerSettings": "Ochrona plików",
  "scannerRefresh": "Sprawdź połączenie",
  "scannerHint": "Skanowanie dotyczy dokumentów dodawanych w sprawie, przesyłanych linkiem i otrzymanych e-mailem.",
  "scannerSwitch": "Skanowanie ClamAV",
  "scannerOn": "Włączone — skaner odpowiada prawidłowo.",
  "scannerOff": "Skanowanie plików jest wyłączone. Nowe pliki nie są sprawdzane przez ClamAV.",
  "scannerUnavailable": "Skanowanie jest włączone, ale skaner nie odpowiada. Nowe pliki zostaną zablokowane do czasu naprawy.",
  "scannerNotConnected": "ClamAV nie jest podłączony do serwera. Włączenie będzie dostępne po konfiguracji.",
  "scannerCannotEnable": "Skaner jest skonfigurowany, ale nie odpowiada. Włączenie będzie dostępne po jego naprawie.",
  "scannerRequired": "Serwer wymaga skanowania. Nie można go wyłączyć w panelu.",
  "scannerDisableTitle": "Wyłączyć skanowanie?",
  "scannerDisableWarning": "Nowe dokumenty będą przyjmowane bez kontroli antywirusowej ClamAV. Ta zmiana zostanie zapisana w audycie.",
  "scannerDisable": "Wyłącz skanowanie",
  "search": "Numer, klient, tytuł lub ubezpieczyciel",
  "all": "Wszystkie",
  "total": "Wszystkie sprawy",
  "open": "Otwarte",
  "overdue": "Zadania po terminie",
  "unmatched": "E-maile do przypisania",
  "estimated": "Wartość szacunkowa",
  "number": "Numer sprawy",
  "caseTitle": "Nazwa sprawy",
  "type": "Rodzaj szkody",
  "origin": "Pochodzenie",
  "customer": "Klient / poszkodowany",
  "email": "E-mail",
  "phone": "Telefon",
  "asset": "Przedmiot szkody",
  "assetType": "Typ przedmiotu",
  "insurer": "Ubezpieczyciel",
  "policy": "Numer polisy",
  "insurerNumber": "Numer szkody w TU",
  "incidentDate": "Data zdarzenia",
  "location": "Miejsce zdarzenia",
  "description": "Opis",
  "amount": "Kwota (zł)",
  "status": "Etap",
  "updated": "Aktualizacja",
  "create": "Utwórz",
  "cancel": "Anuluj",
  "close": "Zamknij",
  "save": "Zapisz",
  "refresh": "Odśwież",
  "next": "Zmień etap",
  "empty": "Brak pozycji",
  "required": "Uzupełnij wymagane pola",
  "error": "Nie udało się wykonać operacji",
  "overview": "Dane sprawy",
  "docs": "Dokumenty",
  "mail": "Korespondencja",
  "tasks": "Zadania i checklista",
  "finances": "Roszczenia i wypłaty",
  "timeline": "Historia i audyt",
  "note": "Notatka do sprawy",
  "upload": "Wgraj dokumenty",
  "uploadHint": "PDF, JPEG, PNG, WEBP, HEIC. Do 5 plików, każdy do 10 MB, łącznie do 25 MB.",
  "chooseFiles": "Wybierz pliki",
  "requestDocs": "Poproś o dokumenty",
  "share": "Udostępnij wybrane",
  "download": "Pobierz",
  "expires": "Ważny do",
  "days": "Ważność w dniach",
  "category": "Jakie dokumenty są potrzebne?",
  "generate": "Utwórz link",
  "copy": "Kopiuj link",
  "copied": "Skopiowano",
  "links": "Udostępnienia",
  "revoke": "Unieważnij",
  "revoked": "Unieważniony",
  "used": "Wykorzystany",
  "active": "Aktywny",
  "expired": "Wygasły",
  "uploadPurpose": "Przesyłanie do BTP",
  "downloadPurpose": "Pobieranie od BTP",
  "uploadLinkTitle": "Link do przesłania dokumentów",
  "uploadLinkHint": "Przekaż link osobie, która ma dosłać dokumenty. Można go użyć tylko raz, przed upływem terminu ważności.",
  "downloadLinkTitle": "Link do pobrania dokumentów",
  "downloadLinkHint": "Przekaż link tylko właściwemu odbiorcy. Każdy, kto go posiada, może pobierać wybrane dokumenty do końca ważności lub unieważnienia linku.",
  "mailPending": "Skrzynka wymaga podłączenia. Wysyłka będzie dostępna po konfiguracji.",
  "to": "Odbiorca",
  "subject": "Temat",
  "body": "Treść wiadomości",
  "send": "Wyślij e-mail",
  "sending": "Wysyłanie…",
  "sent": "Wiadomość wysłana",
  "unconfirmed": "Wysyłka wymaga sprawdzenia w historii. Nie ponawiaj jej, dopóki nie sprawdzisz statusu.",
  "reply": "Odpowiedz",
  "attachments": "Załączniki",
  "taskTitle": "Nazwa zadania / pozycji",
  "due": "Termin",
  "taskKind": "Rodzaj pozycji",
  "task": "Zadanie",
  "checklist": "Checklista",
  "add": "Dodaj",
  "done": "Zakończone",
  "demand": "Roszczenie",
  "decision": "Decyzja TU",
  "payment": "Otrzymana wypłata",
  "financeHint": "Ewidencja kwot w sprawie. Zapis wypłaty nie wykonuje przelewu.",
  "recordKind": "Rodzaj wpisu",
  "date": "Data",
  "claimed": "Roszczenia razem",
  "paid": "Otrzymano",
  "assign": "Przypisz do sprawy",
  "assignCase": "Wybierz sprawę",
  "inboxHint": "Wiadomości wymagające ręcznego przypisania. Załączniki zostaną przeniesione razem z wiadomością.",
  "inboxPending": "Do przypisania",
  "inboxReviewed": "Rozpatrzone",
  "markReviewed": "Oznacz jako rozpatrzoną",
  "reviewConfirm": "Wiadomość zniknie z listy do przypisania, ale pozostanie dostępna w zakładce Rozpatrzone wraz z załącznikami. Możesz ją później przywrócić.",
  "restoreInbox": "Przywróć do przypisania",
  "readOnly": "Dostęp tylko do podglądu",
  "transferTitle": "Dokumenty do sprawy",
  "transferThanks": "Dokumenty dotarły do BTP. Dziękujemy.",
  "transferSend": "Prześlij dokumenty do BTP",
  "transferConfirm": "Wyślij do sprawy",
  "transferPrivacy": "Wybrane pliki zostaną dołączone do tej sprawy.",
  "transferError": "Link jest nieprawidłowy, wygasł lub został wykorzystany. Poproś BTP o nowy link.",
  "source": "Źródło",
  "recordSaved": "Zapisano",
  "back": "Powrót",
  "statusLabels": {
    "NEW": "Nowa",
    "VERIFICATION": "Weryfikacja",
    "INSURER": "W ubezpieczalni",
    "NEGOTIATION": "Negocjacje",
    "PAYMENT": "Rozliczenie",
    "CLOSED": "Zamknięta"
  },
  "typeLabels": {
    "VEHICLE": "Pojazd",
    "PROPERTY": "Nieruchomość",
    "EQUIPMENT": "Sprzęt / maszyny",
    "INVENTORY": "Mienie",
    "LIABILITY": "OC",
    "OTHER": "Inna"
  },
  "originLabels": {
    "OWN": "Własna BTP",
    "EXTERNAL": "Klient zewnętrzny"
  }
};
export const claimsEn = {
  "caseList": "Cases",
  "searchAction": "Search",
  "emptyCases": "No cases found. Change the filters or create a case.",
  "newCaseHint": "Start with the essentials. Add documents, tasks and correspondence after creating the case.",
  "basics": "1. Case and customer",
  "incidentAndPolicy": "2. Incident and insurance",
  "workflow": "Claim stages",
  "overviewShort": "Details",
  "mailShort": "Emails",
  "tasksShort": "Tasks",
  "financesShort": "Finances",
  "timelineShort": "History",
  "people": "People involved",
  "assets": "Damaged assets",
  "policies": "Policies",
  "incident": "Incident",
  "editShort": "Edit",
  "saveNote": "Add note",
  "noPeople": "No people added",
  "noAssets": "No damaged assets added",
  "noPolicies": "No policy added",
  "noDocuments": "No documents have been added to this case yet.",
  "noLinks": "No document links have been created yet.",
  "noEmails": "No correspondence in this case yet.",
  "noTasks": "No tasks or checklist items yet.",
  "noFinances": "No demands, decisions or payments have been recorded yet.",
  "noHistory": "No events in this case history yet.",
  "mailReviewRequired": "The status of this send is uncertain. Check the case history and the mailbox Sent folder before preparing another attempt. Sending again may deliver a duplicate.",
  "mailCheckedNew": "Checked mailbox — new attempt",
  "older": "Show older entries",
  "edit": "Edit case details",
  "role": "Party role",
  "identifier": "Identifier (e.g. VIN, serial number)",
  "roles": {"CUSTOMER":"Customer","INSURED":"Insured","VICTIM":"Victim","PERPETRATOR":"Perpetrator","WITNESS":"Witness","PARTNER":"Partner"},
  "title": "Claims handling",
  "subtitle": "BTP and external customer cases",
  "newCase": "New case",
  "inbox": "Central inbox",
  "scannerSettings": "File protection",
  "scannerRefresh": "Check connection",
  "scannerHint": "Scanning covers documents added to cases, uploaded through links and received by email.",
  "scannerSwitch": "ClamAV scanning",
  "scannerOn": "Enabled — the scanner is responding.",
  "scannerOff": "File scanning is off. New files are not checked by ClamAV.",
  "scannerUnavailable": "Scanning is enabled, but the scanner is unavailable. New files will be blocked until it is fixed.",
  "scannerNotConnected": "ClamAV is not connected to the server. You can enable it after configuration.",
  "scannerCannotEnable": "The scanner is configured but not responding. You can enable it after it is fixed.",
  "scannerRequired": "The server requires scanning. It cannot be disabled here.",
  "scannerDisableTitle": "Turn off scanning?",
  "scannerDisableWarning": "New documents will be accepted without a ClamAV virus check. This change will be recorded in the audit log.",
  "scannerDisable": "Turn off scanning",
  "search": "Number, customer, title or insurer",
  "all": "All",
  "total": "All cases",
  "open": "Open",
  "overdue": "Overdue tasks",
  "unmatched": "Unassigned emails",
  "estimated": "Estimated value",
  "number": "Case number",
  "caseTitle": "Case title",
  "type": "Claim type",
  "origin": "Origin",
  "customer": "Customer / claimant",
  "email": "Email",
  "phone": "Phone",
  "asset": "Damaged asset",
  "assetType": "Asset type",
  "insurer": "Insurer",
  "policy": "Policy number",
  "insurerNumber": "Insurer claim number",
  "incidentDate": "Incident date",
  "location": "Incident location",
  "description": "Description",
  "amount": "Amount (PLN)",
  "status": "Stage",
  "updated": "Updated",
  "create": "Create",
  "cancel": "Cancel",
  "close": "Close",
  "save": "Save",
  "refresh": "Refresh",
  "next": "Change stage",
  "empty": "No items",
  "required": "Complete required fields",
  "error": "The operation failed",
  "overview": "Case details",
  "docs": "Documents",
  "mail": "Correspondence",
  "tasks": "Tasks and checklist",
  "finances": "Demands and payments",
  "timeline": "Timeline and audit",
  "note": "Case note",
  "upload": "Upload documents",
  "uploadHint": "PDF, JPEG, PNG, WEBP, HEIC. Up to 5 files, 10 MB each, 25 MB total.",
  "chooseFiles": "Select files",
  "requestDocs": "Request documents",
  "share": "Share selected",
  "download": "Download",
  "expires": "Expires",
  "days": "Valid for days",
  "category": "Which documents are needed?",
  "generate": "Create link",
  "copy": "Copy link",
  "copied": "Copied",
  "links": "Shared links",
  "revoke": "Revoke",
  "revoked": "Revoked",
  "used": "Used",
  "active": "Active",
  "expired": "Expired",
  "uploadPurpose": "Upload to BTP",
  "downloadPurpose": "Download from BTP",
  "uploadLinkTitle": "Upload documents link",
  "uploadLinkHint": "Share this link with the person sending documents. It can be used once, before it expires.",
  "downloadLinkTitle": "Download documents link",
  "downloadLinkHint": "Share this link only with the intended recipient. Anyone with it can download the selected documents until it expires or is revoked.",
  "mailPending": "Mailbox connection required. Sending will be available after configuration.",
  "to": "Recipient",
  "subject": "Subject",
  "body": "Message",
  "send": "Send email",
  "sending": "Sending…",
  "sent": "Message sent",
  "unconfirmed": "Check the message history before retrying this send.",
  "reply": "Reply",
  "attachments": "Attachments",
  "taskTitle": "Task / checklist item",
  "due": "Due date",
  "taskKind": "Item type",
  "task": "Task",
  "checklist": "Checklist",
  "add": "Add",
  "done": "Done",
  "demand": "Demand",
  "decision": "Insurer decision",
  "payment": "Payment received",
  "financeHint": "Case financial records. Recording a payment does not initiate a transfer.",
  "recordKind": "Record type",
  "date": "Date",
  "claimed": "Total demands",
  "paid": "Received",
  "assign": "Assign to case",
  "assignCase": "Choose a case",
  "inboxHint": "Messages requiring manual assignment. Attachments will follow the message.",
  "inboxPending": "To assign",
  "inboxReviewed": "Reviewed",
  "markReviewed": "Mark as reviewed",
  "reviewConfirm": "This message will leave the assignment queue, but it and its attachments will remain available under Reviewed. You can restore it later.",
  "restoreInbox": "Restore to assignment queue",
  "readOnly": "Read-only access",
  "transferTitle": "Case documents",
  "transferThanks": "Your documents have reached BTP. Thank you.",
  "transferSend": "Send documents to BTP",
  "transferConfirm": "Send to case",
  "transferPrivacy": "Selected files will be attached to this case.",
  "transferError": "This link is invalid, expired or already used. Ask BTP for a new link.",
  "source": "Source",
  "recordSaved": "Saved",
  "back": "Back",
  "statusLabels": {
    "NEW": "New",
    "VERIFICATION": "Verification",
    "INSURER": "With insurer",
    "NEGOTIATION": "Negotiation",
    "PAYMENT": "Settlement",
    "CLOSED": "Closed"
  },
  "typeLabels": {
    "VEHICLE": "Vehicle",
    "PROPERTY": "Property",
    "EQUIPMENT": "Equipment",
    "INVENTORY": "Inventory",
    "LIABILITY": "Liability",
    "OTHER": "Other"
  },
  "originLabels": {
    "OWN": "BTP own",
    "EXTERNAL": "External customer"
  }
};
